// extracted by mini-css-extract-plugin
export var gridItem = "styles-module--gridItem--BZAdd";
export var gridItemContent = "styles-module--gridItemContent--uH9uP";